import ClassDetails from './ClassDetails';
export default ClassDetails;
